import TotalOrder from '../../../../assets/images/MyOrders/My Orders.svg'
import TotalOrderActive from '../../../../assets/images/MyOrders/My Orders_Active.svg'
import DraftBudget from '../../../../assets/images/MyOrders/Draft-Budget.svg'
import Submitted from '../../../../assets/images/MyOrders/Submitted.svg'
import SubmittedActive from '../../../../assets/images/MyOrders/Submitted_Active.svg'
import DraftBudgetActive from '../../../../assets/images/MyOrders/Draft-Budget_Active.svg'
import Approved from '../../../../assets/images/MyOrders/Approved.svg'
import ApprovedActive from '../../../../assets/images/MyOrders/Approved_Active.svg'
import Completed from '../../../../assets/images/MyOrders/Completed.svg'
import CompletedActive from '../../../../assets/images/MyOrders/Completed_Active.svg'
import Rejected from '../../../../assets/images/MyOrders/Rejected.svg'
import RejectedActive from '../../../../assets/images/MyOrders/Rejected_Active.svg'
import Returned from '../../../../assets/images/MyOrders/Returned.svg'
import ReturnedActive from '../../../../assets/images/MyOrders/Returned_Active.svg'
import Cancelled from '../../../../assets/images/Cancelled.svg'
import CancelledActive from '../../../../assets/images/Cancelled_Active.svg'
import { GetStatusIcon } from 'client/utils/IconsUtil'
import { CONSTANTS } from 'client/utils/constants'
import { Datepicker, ReactSelectBox, Tooltip } from 'client/CommonComponents'
import moment from 'moment'
import Unsubmitted from "../../../../assets/images/DraftMyCart.svg"

export const breadcrumlist = [
    {
        text: 'Bulk Orders',
        key: "f1",
    },
    {}
];

export const getOrderList = (bulkOrderGridCount: any) => {
    const orderList = [
        {
            link: bulkOrderGridCount?.totalOrders,
            text: 'TOTAL ORDER',
            icon: TotalOrder,
            activeIcon: TotalOrderActive,
            icontype: 'totalOrder',
            active: 'active',
            displayText: 'Total Order'
        },
        {
            link: bulkOrderGridCount?.submittedOrders,
            subText: 'SUBMITTED',
            icon: Submitted,
            activeIcon: SubmittedActive,
            text: 'PENDING APPROVAL',
            icontype: 'submitted',
            displayText: 'Pending Approval'
        },
        {
            link: bulkOrderGridCount?.approvedOrders,
            subText: 'APPROVED',
            icon: Approved,
            activeIcon: ApprovedActive,
            text: 'FLEET PROCESSING',
            icontype: 'approved',
            displayText: 'Fleet Processing'
        },
        {
            link: bulkOrderGridCount?.completedOrders,
            text: 'COMPLETED',
            icon: CompletedActive,
            activeIcon: Completed,
            subText: 'ASSET IN-SERVICE',
            icontype: 'completed',
            displayText: 'Completed'
        },
        {
            link: bulkOrderGridCount?.returnedOrders,
            text: 'RETURNED',
            icon: Returned,
            activeIcon: ReturnedActive,
            subText: 'NEED MORE INFO',
            icontype: 'returned',
            displayText: 'Returned'
        },
        {
            link: bulkOrderGridCount?.rejectedOrders,
            text: 'REJECTED',
            icon: RejectedActive,
            activeIcon: Rejected,
            subText: 'DENIED',
            icontype: 'rejected',
            displayText: 'Rejected'
        },
        {
            link: bulkOrderGridCount?.cancelledOrders,
            text: 'CANCELLED',
            icon: Cancelled,
            activeIcon: CancelledActive,
            subText: 'CANCELLED REQUEST',
            icontype: 'cancelled',
            displayText: 'Cancelled'
        },
        {
            link: bulkOrderGridCount?.savedOrders,
            text: 'SAVED',
            icon: Unsubmitted,
            activeIcon: Unsubmitted,
            subText: 'DRAFT ORDER',
            icontype: 'saved',
            displayText: 'Saved'
        }
    ]
    return orderList;
}

export const iconReturn = (status: any) => {
    const icon = GetStatusIcon(status)?.icon;
    let classNameTemp = "";
    if (status === CONSTANTS.ORDER_STATUS.FLEET_PROCESSING || status === CONSTANTS.ORDER_STATUS.PROCESSING) {
        classNameTemp = 'fleetprocessingicon statusIcon';
    } else {
        classNameTemp = 'statusIcon'
    }
    return <img src={icon} alt="statusIcon" className={classNameTemp} />;
};

export const CustomDropdownFilterComponent = (props: any) => {
    const {
        column,
        search,
        options,
        setDropdown,
        handleClearFilter = () => { },
    } = props;
    return (
        <div className="date-filter-wrapper">
            <Tooltip content={setDropdown?.current} data-attribute="HomeHelper_Default_Tooltip">
                <ReactSelectBox
                    placeholder={CONSTANTS.SELECT}
                    name={column?.key}
                    onChange={(e: any) => {
                        setDropdown.current = e?.label;
                        search(e?.label);
                    }}
                    className="form-control"
                    value={setDropdown?.current?.length ? { label: setDropdown?.current, text: setDropdown?.current } : { label: CONSTANTS.SELECT, text: CONSTANTS.SELECT }}
                    options={options}
                    isSearchable={true}
                 data-attribute="HomeHelper_Default_SearchSelectBox" />
            </Tooltip>
            <i
                className="fa fa-times-circle-o"
                aria-hidden="true"
                onClick={() => {
                    search(undefined);
                    setDropdown.current = "";
                    handleClearFilter(column?.key);
                }}
            ></i>
        </div>
    );
};

export const CustomDateFilterComponent = (props: any) => {
    const {
        search,
        setDate,
        handleClearFilter = () => { },
        column
    } = props;
    return (
        <div className="date-filter-wrapper">
            <Datepicker
                placeholder="Select"
                value={setDate.current}
                onChangeDate={(date: any) => {
                    search(moment(date).format("MM/DD/YYYY"));
                    setDate.current = date;
                }}
                allowTextInput={false}
             data-attribute="HomeHelper_Default_Datepicker" />
            <i
                className="fa fa-times-circle-o"
                aria-hidden="true"
                onClick={() => {
                    search(undefined);
                    setDate.current = undefined;
                    handleClearFilter(column?.key);
                }}
            ></i>
        </div>
    );
}

export const CustomFilterComponent = (props: any) => {
    const {
        column,
        search,
        value
    } = props;

    return (
        <div className="input-filter-wrapper">
            <Tooltip content={value?.current} data-attribute="HomeHelper_Default_Tooltip_2">
                <input
                    name={column?.key}
                    onChange={(e: any) => {
                        value.current = e?.target.value;
                        search(e?.target.value);
                    }}
                    className="form-control"
                    value={value?.current}
                 data-attribute="HomeHelper_Default_Input" />
            </Tooltip>
         </div>
    ); 
}